export default "__VITE_ASSET__DiE6My2z__"